import React from "react";
import { useLocation } from "react-use";
import { useTranslation } from "react-i18next";
import AdminIcon from "@icons/myicons/sidebar/dots.svg?react";
import { alpha, Box, useTheme } from "@mui/material";
import { MenuItem } from "@components";
import { useMyself } from "@api";
import {
  ROLE_BANKING_API_LOGS_VIEWER,
  ROLE_CROSS_MANDATOR_BANKING_API_LOGS_VIEWER,
  ROLE_CROSS_MANDATOR_STATISTICS_VIEWER,
  ROLE_FINAPI_MANDATOR_ADMIN,
  ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER,
  ROLE_MASTER_DATA_ADMIN,
  ROLE_MULTIBANKING_API_ADMIN,
} from "@constants";
import {
  API_TOKEN_IMPERSONATION_ROLES,
  USER_VIEW_ROLES,
} from "@features/admin/userManagement/permissions";
import { INVOICING_AND_COMPLIANCE_ROLES } from "@features/admin/invoicing/permissions";
import { matchesRoute } from "./matchesRoute";

export const AdminSidebarMenu = () => {
  const { data: user } = useMyself();
  const theme = useTheme();
  const location = useLocation();
  const { t } = useTranslation();

  const shouldShowAdminMenu =
    user?.roles?.includes(ROLE_MASTER_DATA_ADMIN) ||
    user?.roles?.includes(ROLE_MULTIBANKING_API_ADMIN) ||
    user?.roles?.includes(ROLE_BANKING_API_LOGS_VIEWER) ||
    user?.roles?.includes(ROLE_CROSS_MANDATOR_BANKING_API_LOGS_VIEWER) ||
    user?.roles?.includes(ROLE_CROSS_MANDATOR_STATISTICS_VIEWER) ||
    user?.roles?.includes(ROLE_MANDATOR_LEVEL_STATISTICS_VIEWER) ||
    user?.roles?.includes(ROLE_FINAPI_MANDATOR_ADMIN) ||
    user?.roles?.some((role) => USER_VIEW_ROLES.includes(role)) ||
    user?.roles?.some((role) => API_TOKEN_IMPERSONATION_ROLES.includes(role)) ||
    user?.roles?.some((role) => INVOICING_AND_COMPLIANCE_ROLES.includes(role));

  if (!shouldShowAdminMenu) return null;

  return (
    <Box
      display="flex"
      flexDirection="column"
      gap={1}
      pt={1}
      sx={{
        borderTop: `1px solid ${alpha(
          theme.palette.sidebar.textOnSidebar,
          0.2
        )}}`,
      }}
    >
      <MenuItem
        selected={matchesRoute(["/admin", "/admin/*"], location)}
        to="/admin"
        name={t("appSidebar.menu.admin", "Admin")}
        before={<AdminIcon />}
      />
    </Box>
  );
};
